export default __webpack_public_path__ + "static/media/well.8eac68c3.png";